module.exports = __webpack_public_path__ + "static/media/fr.684cc20f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/lang/fr.svg
// module id = 611
// module chunks = 0